<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <simple-izbirnik :seznam="vseStranke" v-model="izbranaStranka"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine" v-if="vsaOprema !== null && Object.keys(vsaOprema).length > 0">
        <p class="open-sans-30pt" style="padding-bottom: 20px">
          Nastavitve mrežne opreme
        </p>
        <template v-if="izbranaStranka !== null">
          <div class="odmik-izbire-mrezne-opreme d-flex mb-3" :style="`flex-direction: ${['sm', 'xs'].indexOf($screen.breakpoint) > -1 ? 'column' : 'row'};`">
            <div class="my-auto" style="width: 200px">Nastavitve za priključek</div>
            <simple-izbirnik
              v-model="izbranPrikljucek"
              :seznam="vsiPrikljucki[izbranaStranka]"
              no-data-text="Ni priključkov"
              placeholder="Izberite priključek"
            />
          </div>
        </template>
        <div v-loading="loadingOpremo">
          <div v-if="seznamOpreme.length > 0">
            <div>
              <div class="odmik-izbire-mrezne-opreme d-flex mb-2" :style="`flex-direction: ${['sm', 'xs'].indexOf($screen.breakpoint) > -1 ? 'column' : 'row'};`">
                <div class="my-auto" style="width: 200px">Nastavitve za opremo</div>
                <el-select v-model="idIzbranaOprema" placeholder="Oprema" class="velikost-izbirnika-strank">
                  <el-option v-for="(data) in seznamOpreme"
                             :value="data.id_oprema_prikljucek"
                             :label="data.oznaka + ' (' + data.serijska_st + ')'"
                             :key="data.id_oprema_prikljucek" />
                </el-select>
              </div>
            </div>
            <div class="odmik-tabov">
              <el-tabs type="border-card" value="t1" v-if="povezanoVOmrezje !== null && !loadingOpremo">
                <el-tab-pane label="Brezžično omrežje" name="t1" ref="t1">
                  <div>
                    <MultipleWifiNetworks
                      v-if="multipleWifiNetworksEquipmentEnum.includes(izbranaOpremaIdent)"
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                    <wifi
                      v-else
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane
                  label="Telefonija"
                  name="t3"
                  v-if="!multipleWifiNetworksEquipmentEnum.includes(izbranaOpremaIdent)">
                  <div>
                    <voip
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Posredovanje vrat" name="t4">
                  <div>
                    <portforward
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="DMZ" name="t5">
                  <div>
                    <dmz
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Rezervacija IP" name="t6">
                  <div>
                    <RezervacijaIp
                      v-on:successNotification="SuccessNotification"
                      :povezano-v-omrezje="povezanoVOmrezje"
                      :idIzbranaOprema="idIzbranaOprema"/>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="vsebina-postavitev" v-else>
        <div class="odmik-vsebine">
          <p class="open-sans-30pt">
            Nastavitve mrežne opreme
          </p>
          <div>
            <div class="odmik-vsebine" style="padding-left: 0;">
              <div>
                <div class="postavitev-slike">
                  <img src="/static/img/Nastavitve/MreznaOprema/MojT2_Portal_Nastavitve_Onemogoceno.png" alt="">
                </div>
                <div class="postavitev-vsebine">
                  <p class="navadno-besedilo">
                    Na vašem uporabniškem računu nimate opreme, ki jo lahko upravljate na portalu Moj T-2.
                    <br/>
                    <br/>
                    Za več informacij nas lahko pokličete na številko {{kontaktniPodatki.T2_SUPPORT_TEL_ST}}
                    ali nam pišete na {{kontaktniPodatki.T2_INFO_EMAIL}}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import portforward from './tr069/Portforward.vue'
import wifi from './tr069/Wifi.vue'
import dmz from './tr069/Dmz.vue'
import voip from './tr069/Voip.vue'
import {Tabs, TabPane, Option, Select, Tooltip, Switch} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {KontaktniPodatkiEnum} from '../../../../assets/js/Enum/KontaktniPodatkiEnum.js'
import RezervacijaIp from './tr069/RezervacijaIp.vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'
import {MultipleWifiNetworksEquipmentEnum} from '../../../../assets/js/Enum/MultipleWifiNetworksEquipmentEnum'
import MultipleWifiNetworks from './tr069/MultipleWifiNetworks.vue'
import SimpleIzbirnik from '../GlobalneKomponente/SimpleIzbirnik.vue'
import {PridobiStranko} from '../../../../assets/js/globalne_funkcije/PridobivanjeStranke/PridobiStranko'
import PrivzetaVrednostLogic from '../../../../assets/js/globalne_funkcije/PrivzetaVrednostLogic'
import {PrivzetaVrednostTipEnum} from '../../../../assets/js/Enum/PrivzetaVrednostTipEnum'

export default {
  name: 'NastavitveMreznaOprema',
  mixins: [PridobiStranko],
  data () {
    return {
      title: 'Nastavitve mrežne opreme',
      clientAgent: null,
      izbranPrikljucek: '',
      seznamOpreme: [],
      idIzbranaOprema: '',
      loadingOpremo: true,
      kontaktniPodatki: '',
      seznamNosilnihPrikljuckov: [],
      izbranaStranka: null,
      selectorPermissions: ['STRANKE'],
      povezanoVOmrezje: null,
      loadingConnectedDevice: null,
      izbranaOpremaIdent: null,
      multipleWifiNetworksEquipmentEnum: MultipleWifiNetworksEquipmentEnum,
      vsaOprema: null,
      vseStranke: null,
      vsiPrikljucki: () => {}
    }
  },
  components: {
    SimpleIzbirnik,
    MultipleWifiNetworks,
    IzbirnikPrikljuckaSelect,
    IzbirnikStranke,
    'RezervacijaIp': RezervacijaIp,
    'portforward': portforward,
    'wifi': wifi,
    'dmz': dmz,
    'voip': voip,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Switch.name]: Switch
  },
  watch: {
    izbranaStranka () {
      this.izbranPrikljucek = null
    },
    izbranPrikljucek: function (val) {
      if (val !== '' && val !== null) {
        this.SetSeznamOpreme()
      }
    },
    idIzbranaOprema: function (val) {
      if (this.val !== '') {
        this.GetConnectedInfo(val)
        this.seznamOpreme.forEach(oprema => {
          if (oprema.id_oprema_prikljucek === val) {
            this.izbranaOpremaIdent = oprema.ident
          }
        })
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.kontaktniPodatki = KontaktniPodatkiEnum
    this.GetUserData()
  },
  methods: {
    PrenosniPodatkiStranka () {
      this.naloziVsoOpremo()
    },
    async naloziVsoOpremo () {
      let req = {permissionId: 'TR_OPREMA'}
      try {
        let vsaOpremaResponse = await this.clientAgent.makeRequest('permissions/havePermission', req, 'POST')
        let tmpStrankeIDs = []
        let tmpStrankeVse = []
        let tmpPrikljuckiIDs = []
        let tmpPrikljuckiVse = {}
        let tmpVsaOprema = {}
        vsaOpremaResponse.permission.additionalData.forEach(oprema => {
          if (tmpStrankeIDs.indexOf(oprema.id_stranka) === -1) {
            if (oprema.id_stranka_sap === PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.SAP)) {
              this.izbranaStranka = oprema.id_stranka
            }
            tmpStrankeIDs.push(oprema.id_stranka)
            tmpStrankeVse.push({
              value: oprema.id_stranka,
              label: `${oprema.stranka_ime === '' ? '' : oprema.stranka_ime + ' '}${oprema.stranka_priimek} (${oprema.id_stranka_sap})`
            })
          }
          if (tmpPrikljuckiIDs.indexOf(oprema.id_prikljucek) === -1) {
            if (oprema.id_prikljucek === PrivzetaVrednostLogic.getInstance().GetPrivzetaVrednost(PrivzetaVrednostTipEnum.FIX_PRIKLJUCEK)) {
              this.izbranPrikljucek = oprema.id_prikljucek
            }
            tmpPrikljuckiIDs.push(oprema.id_prikljucek)
            if (tmpPrikljuckiVse[oprema.id_stranka] === undefined) {
              tmpPrikljuckiVse[oprema.id_stranka] = []
            }
            tmpPrikljuckiVse[oprema.id_stranka].push({
              value: oprema.id_prikljucek,
              label: oprema.naslov
            })
          }
          if (tmpVsaOprema[oprema.id_stranka] === undefined) {
            tmpVsaOprema[oprema.id_stranka] = {}
          }
          if (tmpVsaOprema[oprema.id_stranka][oprema.id_prikljucek] === undefined) {
            tmpVsaOprema[oprema.id_stranka][oprema.id_prikljucek] = []
          }
          tmpVsaOprema[oprema.id_stranka][oprema.id_prikljucek].push(oprema)
        })
        this.vseStranke = tmpStrankeVse
        this.vsiPrikljucki = tmpPrikljuckiVse
        this.vsaOprema = tmpVsaOprema
      } catch (e) {
        e.duration = 0
        this.ShowErrorMessage(e)
      }
    },
    GetConnectedInfo (prenosniParamIdOprema) {
      if (prenosniParamIdOprema !== '') {
        this.loadingOpremo = true
        let param = ['idOprema=' + this.idIzbranaOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/wan/info',
          param,
          null,
          'SetConnectedInfo',
          'ErrConnectedInfo')
      }
    },

    SetConnectedInfo (podatki) {
      this.povezanoVOmrezje = podatki.data.length !== 0
      this.loadingOpremo = false
    },
    ErrConnectedInfo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    SetSeznamOpreme () {
      this.seznamOpreme = this.vsaOprema[this.izbranaStranka][this.izbranPrikljucek]
      if (this.seznamOpreme.length > 0) {
        for (let i = 0; i < this.seznamOpreme.length; i++) {
          if (typeof this.seznamOpreme[i].id_oprema_prikljucek !== 'undefined') {
            this.idIzbranaOprema = this.seznamOpreme[i].id_oprema_prikljucek
            this.izbranaOpremaIdent = this.seznamOpreme[i].ident
            break
          }
        }
      }
    },
    SuccessNotification () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Podatki so bili uspešno posodobljeni. Osvežen prikaz bo na voljo v nekaj minutah.'
      this.ShowSuccessMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="./../../../../../static/css/Nastavitve/MreznaOprema/MreznaOprema.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveMreznaOprema.vue